export default __webpack_public_path__ + "static/media/purchase-profile-inact.8913cecd.svg";